import { DateRange } from "react-day-picker";
import { creatFotaType, PublishFotaType } from "./apiBodyTypes";
import { makeDeleteRequest, makePostRequest } from "./restServices";

async function fetchAllFotas(
  sortKey: string,
  sortOrder: string,
  search: string,
  filters: string[],
  creationDateRange: DateRange | undefined
) {
  try {
    const response = await makePostRequest("fota/get-all-fotas", {
      sortKey,
      sortOrder,
      search,
      filters,
      creationDateRange,
    });
    if (response.data.success) {
      return response.data.data;
    }
    throw new Error("Failed to fetch fotas");
  } catch (error) {
    console.error("Error in getAllFotas:", error);
    return [];
  }
}

async function createFota(body: creatFotaType) {
  try {
    const response = await makePostRequest("fota/create-fota", body);
    return response.data;
  } catch (error) {
    console.error("Error in createFota:", error);
    return { success: false, data: null };
  }
}
async function deleteFota(fotaId: string) {
  try {
    const response = await makeDeleteRequest(`fota/${fotaId}`);
    return response.data;
  } catch (error) {
    console.error("Error in createFota:", error);
    return { success: false, data: null };
  }
}

async function publishFota(body: PublishFotaType) {
  console.log("body:", body);
  try {
    const response = await makePostRequest(
      "device/update-bulk-desired-SWVersion",
      body
    );
    return response.data;
  } catch (error) {
    console.error("Error in createFota:", error);
    return { success: false, data: null };
  }
}

export { fetchAllFotas, createFota, deleteFota, publishFota };
